export default __webpack_public_path__ + "static/media/codeEditor.ba945879.png";